module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-family": "Calisto MT",
      "font-size": "18pt",
      "letter-spacing": "1px",
      "padding-top": "75px",
      "padding-bottom": "15px"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Vaul Impera is the originator and creator of Immortalaeism, and the first to adopt it as a philosophical/spiritual paradigm. He has been offered international law to fight against sex trades by Parliament of Canada. He has been offered leadership positions in the army, and he has been offered high positions in the Church.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0